// extracted by mini-css-extract-plugin
export var brand = "_87-9";
export var compact = "_87-6";
export var extraSmall = "_87-7";
export var icon = "_87-0";
export var large = "_87-4";
export var light = "_87-1";
export var medium = "_87-5";
export var outline = "_87-b";
export var primaryDark = "_87-a";
export var primaryLight = "_87-8";
export var primaryModern = "_87-c";
export var success = "_87-2";
export var successSolid = "_87-3";